<template>
  <div style="position: relative;">
      <div class="title" style="display: flex;flex-direction: row;" >
        <span v-for="(item,index) in title" :style="activeList[index]?textStyle:disableStyle" @click="switchTab(index)" class="text" :ref="index" >
          {{item}}
        <div class="active-line" :style="{backgroundColor:activeList[index]?color:(title.length>1?'transparent':color)}" :ref="index+'line'"></div>
        </span>
      </div>
    <div class="line"></div>
  </div>
</template>


<script>
export default {
  name: 'tabTitle',
  data(){
    return{
      count:1,
      activeList: [],
      textStyle:{
        color:this.title.length===1?"#a0a0a0":this.color
      },
      disableStyle:{
        color:"#a0a0a0"
      }
    }
  },
  created () {
    let len=this.title.length
    for(let i=0;i<len;i++){
      this.activeList.push(false)
    }
    if(len>1){
      this.activeList[0]=true
    }
  },
  methods:{
    switchTab(index){
      let that=this
      this.$nextTick(()=>{

        if(that.activeList.length>1){
          console.log(that.activeList)

          if(!that.activeList[index]){
            for(let i=0;i<that.activeList.length;i++){
              if(i!==index){
                that.$refs[i][0].style.color='#a0a0a0'
                that.$refs[i+'line'][0].style.backgroundColor='transparent'
                that.activeList[i]=!that.activeList[i]
              }
              else{
                that.$refs[index][0].style.color=this.color
                that.$refs[index+'line'][0].style.backgroundColor=this.color
                that.activeList[index]=!that.activeList[index]
                that.$emit('switchPage',that.title[index])
              }
            }
          }

        }
      })

    }
  },
  props:{
    title:{
      type:Array,
      default:'标题'
    },
    color:{
      type:String,
      default:'#a0a0a0'
    }
  }
}
</script>

<style scoped>
.title{
  margin: 0vw 1vw 0.1vw;
  width: 4.8vw;

  height: 1.3vw;
  font-family: SourceHanSansCN-Medium;
  font-size: 0.7vw;
  font-weight: normal;
  font-stretch: normal;
  line-height: 1.5vw;
  letter-spacing: 0.1vw;
  white-space: nowrap;
  position: relative;
}
.active-line{
  width: 3.5vw;
  height: 2px;
  position: absolute;
  z-index: 10;
  top:2vw;
  margin-right: 1.5vw;
}
.line{
  position: absolute;
  top:2vw;
  display: inline-block;
  left: 1vw;
  width: 95%;
  height: 1px;
  background-color: #a0a0a0;
  margin: 1px auto 0;
}

.text{
  display: inline-block;
  margin-right: 1vw;
  cursor: pointer;

}
</style>
